export default {
  SET_CONTRACT_DETAILS(state,data){
    state.contractDetail = data
  },



  SET_APPLICATIONS_MATERIAL(state, data) {
    data.results.forEach((elem) => {
      elem.checked = false
    })
    state.applicationMaterial = data
  },
  SET_APPLICATIONS_MATERIAL_ID(state, data) {
    state.applicationMaterialId = data
  },



  SET_APPLICATION_INSTRUMENT(state, data) {
    data.results.forEach((elem) => {
      elem.checked = false
    })
    state.applicationInstrument = data
  },
  SET_APPLICATIONS_INSTRUMENT_ID(state, data) {
    state.applicationInstrumentId = data
  },
 
 
 
  SET_APPLICATION_TRANSPORT(state, data) {
    data.results.forEach((elem) => {
      elem.checked = false
    })
    state.applicationTransport = data
  },
  SET_APPLICATIONS_TRANSPORT_ID(state, data) {
    state.applicationTransportId = data
  },




  SET_APPLICATION_STATUS(state, data) {
    state.applicationStatus = data
  },
  SET_APPLICATION_USER(state, data) {
    state.applicationAuthor = data
  },
  SET_APPLICATION_TYPE(state, data) {
    state.applicationType = data
  },
  SET_APPLICATION_STATUS_TIMELINE(state, data) {
    state.applicationStatusTimeLine = data
  },
  SET_APPLICATION_STATUS_TIMELINE_BY_ID(state, data) {
    state.applicationStatusTimeLineById = data
  },
  SET_APPLICATION_STATUS_CHILD_TIMELINE(state, data) {
    state.applicationStatusChildTimeLine = data
  },




  SET_APPLICATION_STATUS_MOVEMENT_TIMELINE(state, data) {
    state.applicationStatusMovementTimeLine = data
  },
  SET_APPLICATION_MATERIAL_MOVEMENT(state, data) {
    state.applicationMaterialMovement = data
  },
  SET_APPLICATION_INSTRUMENT_MOVEMENT(state, data) {
    state.applicationInstrumentMovement = data
  },



  SET_APPLICATION_PURCHASE(state, data) {
    state.purchase = data
  },

  SET_APPLICATION_INSTRUMENT_RETURN(state, data) {
    state.instrumentReturn = data
  },
  SET_APPLICATIONS_GOOD_RETURN(state, data) {
    state.goodReturn = data
  },






  SET_APPLICATION_FOR_BRIGADE_WORKS(state, data) {
    state.brigadeWorks = data
  },
  SET_ONE_APPLICATION_FOR_BRIGADE_WORKS(state, data) {
    state.oneBrigadeWorks = data
  },
  
  
  SET_REFRESH_VIEW_MATERIAL(state, data) {
    state.refreshViewMaterial = data
  },


  PUSH_WORK_FILES(state, data) {
    state.workFiles.push(data)
  },
  SET_WORK_FILES(state, data) {
    state.workFiles = data
  },
  
  
  
  
  SET_PARTIAL_PAYMENTS_FOR_BRIGADE_WORKS(state, data) {
    state.workPartialPayments = data
  },
  SET_ONE_PARTIAL_PAYMENTS_FOR_BRIGADE_WORKS(state, data) {
    state.oneWorkPartialPayment = data
  },
  
  
  
  
  
  
  SET_REPORT_REQUIREMENT_FOR_BRIGADE(state, data) {
    state.report_requirement_for_brigade = data
  },
  SET_REPORT_REQUIREMENT_FOR_BRIGADE_BY_WORK_TYPE(state, data) {
    state.report_requirement_for_brigade_by_work_type = data
  },
  SET_REPORT_REQUIREMENT_FOR_BRIGADE_BY_WORK_CATEGORY(state, data) {
    state.report_requirement_for_brigade_by_work_category = data
  },
  SET_REPORT_REQUIREMENT_FOR_GOOD(state, data) {
    state.report_requirement_for_good = data
  },
  SET_REPORT_REQUIREMENT_FOR_GOOD_MATERIAL_TYPE(state, data) {
    state.report_requirement_for_good_material_type = data
  },
  
  
  
  SET_WORKER_WRITE_OFF_FOR_GOOD(state, data) {
    state.worker_write_off_for_good = data
  },
  SET_WORKER_WRITE_OFF_FOR_INSTRUMENT(state, data) {
    state.worker_write_off_for_instrument = data
  },

}
